import DetailFields from './CapacityDetailFields';
import KeyStatusBadge from '../../../components/KeyStatusBadge';
import { formatCapacityDate } from './formatCapacityDate';
import type { ReactNode } from 'react';
import type { OrderContext } from './model';

export default function OrderContextSummary({ order, hideContainer = false, onOpenPro }: { order: OrderContext; hideContainer?: boolean; onOpenPro: (pro: number) => void }) {
  const fields: [string, ReactNode][] = [
    ['Customer', order.customer],
    ['Market', order.market],
    ['Move', order.move],
    ['Local / OTR', order.pool],
    ['Live unload / Drop', order.handling || 'Not supplied'],
    ...(!hideContainer ? [['Size / type', order.size], ['Container', order.container]] as [string, ReactNode][] : []),
    ['Pick up', order.pickup],
    ['Delivery', order.delivery],
    ['Leg miles', order.miles],
    ...(order.move === 'IMPORT' ? [['LFD', formatCapacityDate(order.lfd)]] as [string, ReactNode][] : order.move === 'EXPORT' ? [['ERD', formatCapacityDate(order.erd)], ['Cutoff', formatCapacityDate(order.cutoff)]] as [string, ReactNode][] : []),
    ['Key account', order.keyTier && order.keyTier.trim().toUpperCase() !== 'AVERAGE' ? <KeyStatusBadge status={order.keyTier} className="self-center" /> : order.keyTier || '—'],
  ];
  return <section className="rounded-lg border border-theme-border-primary bg-panel p-4">
    <h3 className="mb-3 text-sm font-semibold text-heading">From PRO <button type="button" className="text-blue-600 hover:underline focus-visible:rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 dark:text-blue-400" aria-label={`Open PRO ${order.pro}`} onClick={() => onOpenPro(Number(order.pro))}>{order.pro}</button></h3>
    <DetailFields fields={fields} />
  </section>;
}
